/**
 *  couriers.js
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

import * as actionTypes from '../actions/actionTypes';

const initialState = {
    couriers: []
};

export const couriers = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SAVE_COURIERS:
            return {
                ...state,
                couriers: action.couriers
            };
        case actionTypes.CLEAR_COURIERS:
            return {
                ...state,
                couriers: []
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/couriers.js